import {Card, Container, GlyphChip} from '@multipass-ui-components';
import * as React from 'react';

const quotes: {quote: string; initial: string; name: string; who: string}[] = [
    {
        quote: '"Splitting pronunciation out from meaning was the thing. I could always read 謝謝 — turns out I couldn\'t say it. Now it keeps asking me to."',
        initial: 'M', name: 'Mei L.', who: 'Intermediate learner',
    },
    {
        quote: '"Two minutes on the platform, ten before bed. It never punishes me for a short session, so I keep doing short sessions."',
        initial: 'O', name: 'Owen W.', who: 'Commuter, ADHD',
    },
    {
        quote: '"I did a whole week of reviews on a flight with the wifi off and it just picked up where it left off when I landed."',
        initial: 'S', name: 'Sam K.', who: 'Returning learner',
    },
];

export const SocialProof: React.FunctionComponent = () => (
    <section id="proof" className="py-16">
        <Container>
            <div className="mx-auto mb-10 max-w-[60ch] text-center">
                <h2 className="mb-3 text-headline">Loved by self-directed learners</h2>
            </div>
            <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-5">
                {quotes.map(({quote, initial, name, who}) => (
                    <Card key={name}>
                        <p className="mb-4 text-body">{quote}</p>
                        <div className="flex items-center gap-3">
                            <GlyphChip size="lg" shape="circle">{initial}</GlyphChip>
                            <div>
                                <b className="block text-label">{name}</b>
                                <span className="text-caption text-text-muted">{who}</span>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </Container>
    </section>
);
